let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kKZ2R")).then(() => parcelRequire('unuyV'));